import React from "react";
import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";

import styled from "styled-components";

const CardHead = styled.h3`
  margin-bottom: 5px;
`;

const CardSubHead = styled.h4`
  margin-bottom: 10px;
  color: #131010;
  font-weight: 600;
`;

const CardDetailText = styled.li`
  color: #141313;
  margin: 5px;
`;

const Responsibilities = styled.div`
  color: #000000;
  font-size: 16px;
  font-weight: 600;
  margin: 10px 0;
  letter-spacing: 0.2ch;
`;

function ChronoTimeline({ currentTheme }) {
  const items = [
    {
      title: "November 2020 - Present",
      cardSubtitle: "Masai School",
      cardTitle: "Full Stack Web Development",
      cardDetailedText: ["A full stack web development course.",
    "Learning diffrent stacks such as HTML, CSS, JavaScript, Mongoose,MongoDB, React and Hooks",
  "Learning Data Structure and Problem-Solving",
"Learn soft skills such as Time-Management, Team work, Communication,Leardership,Given multiple Presentations"],
    },
    {
      title: "January 2022 - Present",
      cardTitle: "Student Guide",
      cardSubtitle: "Masai School",
      cardDetailedText: [
        "Guiding 15-20 students of junior batches",
        "weekly taking group meeting and one to one meet to all the student assigned",
        "Helping them in the course and giving Proper Guidence when ever is required",
       
      ],
      internship: true,
    },
    {
      title: "June 2020- Nov 2020",
      cardTitle: "Community influencer",
      cardSubtitle: "MentorBoxx",
      cardDetailedText: [
        "Creating short-form content and strategic deals to offer benefits to social communities.",
        "Developing relationships with influencers to ensure company reputation is promoted.",
        "Creating marketing content and materials for influencer communication.",
        "Adding value to key influencers by helping them to grow and drive monetization",
      ],
      internship: true,
    },

    {
      title: "October 2020",
      cardSubtitle: "Dr. A.P.J. Abdul Kalam Technical University",
      cardTitle: "B.E Civil Engineering",
      cardDetailedText: [
        "An undergraduate Civil  Engineering course",
      ],
    },
  ];

  return (
    <VerticalTimeline animate={false} position="left">
      {items?.map((history) => (
        <EducationTimelineCard
          key={history.school}
          currentTheme={currentTheme}
          {...history}
        />
      ))}
    </VerticalTimeline>
  );
}

function EducationTimelineCard({
  title,
  cardTitle,
  cardSubtitle,
  cardDetailedText,
  internship,
  currentTheme,
}) {
  return (
    <VerticalTimelineElement
      className="vertical-timeline-element--work"
      contentStyle={{
        textAlign: "left",
        background: "#ffffff",
        color: "#fff",
      }}
      contentArrowStyle={{ borderRight: "7px solid  #ffffff" }}
      date={title}
      iconStyle={{
        background: `${currentTheme === "light" ? "#FEC107" : "#C50E6A"}`,
        color: "#1a1111",
        transform: "scale(0.4)",
      }}
    >
      <CardHead
        style={{ color: "#000000" }}
        className="vertical-timeline-element-title"
      >
        {cardTitle}
      </CardHead>
      <CardSubHead
        style={{ color: "#393e46" }}
        className="vertical-timeline-element-subtitle"
      >
        {cardSubtitle}
      </CardSubHead>
      {internship && (
        <Responsibilities>
          <b>Responsibilities</b>
        </Responsibilities>
      )}

      <ul>
        {cardDetailedText.map((item) => (
          <CardDetailText key={item.title}>{item}</CardDetailText>
        ))}
      </ul>
    </VerticalTimelineElement>
  );
}

export { ChronoTimeline };
